<template>
    <div class="page">
        <div class="video-parent">
            <video v-if="videoUrl.length>0" class="video-area" controls id="video">
                <source :src="videoUrl" type="video/mp4"/>
            </video>
            <img :src="coverUrl" v-if="coverUrl.length>0" class="video-pic"/>
            <div class="video-play-area" v-if="coverUrl.length>0" @click="playVideo">
                <img src="../assets/video_play.png"  class="video-play"/>
            </div>
        </div>

        <div class="news-title">{{title}}</div>
        <div class="news-time">{{time}}</div>
        <div v-html="content" class="foo"></div>
    </div>
</template>

<script>
    import {healthDetail} from '@/api/api'
    export default {
        name: "news-detail",
        data(){
            return{
                videoUrl:'',
                title:'',
                time:'',
                healthId:this.$route.query.healthId?this.$route.query.healthId:-1,
                content:'',
                coverUrl:''
            }
        },
        created(){
            this.getNewsDetail()
        },
        methods:{
            playVideo(){
                this.coverUrl = ''
                var myVideo = document.getElementById('video');//获取video元素
                myVideo.play()
            },
            getNewsDetail(){
                let params = {
                    id:this.healthId
                }
                healthDetail(params).then(res=>{
                    if (res.code==0){
                        this.title = res.data.health.title
                        this.time = res.data.health.createdate
                        this.content = res.data.health.content
                        this.videoUrl = res.data.health.videoUrl
                        let imgList = []
                        if (res.data.health.pictureUrl && res.data.health.pictureUrl.length>0){
                            if (res.data.health.pictureUrl.indexOf(',') !== -1){
                                imgList = res.data.health.pictureUrl.split(",");
                            }else{
                                imgList.push(info.pictureUrl)
                            }
                        }
                        if (imgList.length > 0){
                            this.coverUrl = imgList[0]
                        }
                    }
                })
            },
        }
    }
</script>

<style scoped>
    .page{
        margin-left: 16px;
        margin-right: 16px;
    }
    .news-title{
        font-size:20px;
        font-family:PingFangSC-Semibold,PingFang SC;
        font-weight:600;
        color:rgba(40,43,49,1);
        line-height:28px;
        margin-bottom: 12px;
        margin-top: 25px;
    }
    .news-time{
        font-size:12px;
        font-family:PingFangTC-Regular,PingFangTC;
        font-weight:400;
        color:rgba(153,158,168,1);
        line-height:17px;
        margin-bottom: 40px;
    }
    .foo >>> img { max-width: 100%; }
    .video-area{
        width: 100%;
        height: 210px;
    }
    .video-parent{
        width: 100%;
        height: 210px;
        position: relative;
    }
    .video-pic{
        width: 100%;
        height: 210px;
        position: absolute;
        top: 0;
        left: 0;
    }
    .video-play-area{
        width: 100%;
        height: 210px;
        position: absolute;
        top: 0;
        left: 0;
        display: flex;
        justify-content: center;
        align-items: center;
    }
    .video-play{
        width: 80px;
        height: 80px;

    }
</style>